import { __rest, __awaiter } from '../../node_modules/tslib/tslib.es6.js';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import _toNumber from 'lodash/toNumber';
import React__default, { useState, useCallback, useEffect } from 'react';
import { searchBrandClubsForUserV2, getUnauthedSearchBrandClubs } from '../../api/graphQl/brand.js';
import { UNAUTHENTICATED_SEARCH_PRODUCTS, ProductOperation } from '../../api/graphQl/product.js';
import '../../Components/Animation/AnimationDot.js';
import '../../icons/abstract/AbstractArcIcon.js';
import '../../icons/AddCircleIcon.js';
import '../../icons/AddCircleOutlineIcon.js';
import '../../icons/ArrowCircleRightIcon.js';
import '../../icons/ArrowLeftIcon.js';
import '../../icons/ArrowRightIcon.js';
import '../../icons/BoltIcon.js';
import '../../icons/BookmarkStarIcon.js';
import '../../icons/CalendarIcon.js';
import '../../icons/CancelIcon.js';
import '../../icons/CheckCircleIcon.js';
import '../../icons/CheckMarkIcon.js';
import '../../icons/ChevronDownIcon.js';
import '../../icons/ChevronLeftIcon.js';
import '../../icons/ChevronRightIcon.js';
import '../../icons/ChevronUpIcon.js';
import '../../icons/CloseIcon.js';
import '../../icons/CopyIcon.js';
import '../../icons/MenuIcon.js';
import '../../icons/NotificationActiveIcon.js';
import '../../icons/PaperPlaneIcon.js';
import '../../icons/PendingIcon.js';
import '../../icons/PersonIcon.js';
import '../../icons/PlayCircleIcon.js';
import '../../icons/RemoveCircleIcon.js';
import '../../icons/SearchIcon.js';
import '../../icons/SellIcon.js';
import '../../icons/ShareIcon.js';
import '../../icons/ShoppingBagIcon.js';
import '../../icons/SmartphoneIcon.js';
import '../../icons/StarIcon.js';
import '../../icons/StarOutlineIcon.js';
import '../../icons/SuccessCheckCircleIcon.js';
import '../../icons/ThumbsDownIcon.js';
import '../../icons/ThumbsUpIcon.js';
import '../../icons/TuneIcon.js';
import '../../icons/FourPointStarIcon.js';
import { Button } from '../../Components/Button/Button.js';
import '../../Components/Button/CustomDtcBagButton.js';
import '../../Components/BuyBoxDialog/BuyBoxType.js';
import '../../Components/BuyBoxDialog/PriceDialogContent.js';
import '../../Components/BuyBoxDialog/ProductPrice.js';
import '../../Components/ImageCropper/ImageCropper.js';
import '@mui/material';
import 'immer';
import '../../Components/automated-theme-setup/DraggableThemeFab.js';
import '@mui/icons-material/ExpandMore';
import '@mui/icons-material/Palette';
import '@mui/icons-material/TextFields';
import '@mui/icons-material/Settings';
import '@mui/icons-material/Notes';
import '@mui/icons-material/SmartButton';
import '../../Components/automated-theme-setup/CustomColorPicker.js';
import '../../analytics/events.js';
import 'uuid';
import 'lodash/includes';
import '../../types/filters.js';
import '../../utils/assetUtils.js';
import '../../utils/brandclubStoreConfigUtils.js';
import 'numeral';
import '../../utils/stringUtils.js';
import '../../utils/broadcast.js';
import { WIDGET_SPACE, TABLET_SCREEN_SIZE, WIDGET_SPACE_HALF, DESKTOP_SCREEN_SIZE, DESKTOP_HORIZONTAL_PADDING, TABLET_HORIZONTAL_PADDING, MOBILE_SCREEN_SIZE, MOBILE_HORIZONTAL_PADDING } from '../../utils/constants/Constants.js';
import 'awesome-phonenumber';
import 'lodash/isEqual';
import { useJoinBrandClubWithRedirect } from '../../utils/hooks/useJoinBrandClub.js';
import '@splitsoftware/splitio-react';
import '@tanstack/react-query';
import '../../Auth/index.js';
import '../../types/Campaign.js';
import 'lodash/get';
import 'lodash/orderBy';
import '../../types/product.js';
import '../../api/cache/appConfigQueryOptions.js';
import '@brandclub/types';
import 'lodash/omitBy';
import 'lodash/isNil';
import '../../utils/logger.js';
import 'lodash/merge';
import '@mui/material/CircularProgress';
import 'react-lottie';
import '../../Components/automated-theme-setup/ThemeElementSelector.js';
import '../../Components/Dialog/ResponsiveDialog.js';
import { FilterDialog } from '../BrandclubNavigation/FilterDialog.js';
import ProductBrandCard from '../components/BrandclubProductCard/ProductBrandCard.js';
import { GenericContainer } from '../components/GenericContainer.js';
import { StoreBrandingType } from '../type.js';
import SearchProductGrid from './SearchProductGrid.js';
import { searchParamsToSearchFilters } from './searchResultsUtils.js';

const PAGE_SIZE = 60;
const SearchResultsContainer = styled(GenericContainer)(({ theme }) => ({
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    paddingTop: 30,
    paddingBottom: WIDGET_SPACE,
    paddingLeft: '5%',
    paddingRight: '5%',
    boxSizing: 'border-box',
    color: theme.vars.palette.text.primary,
    [`@media screen and (max-width: ${TABLET_SCREEN_SIZE}px)`]: {
        backgroundColor: '#fff',
        padding: `${WIDGET_SPACE_HALF}px ${0}px`,
    },
}));
const ContentWrapper = styled(Grid)({
    maxWidth: DESKTOP_SCREEN_SIZE - DESKTOP_HORIZONTAL_PADDING * 2,
    width: '100%',
    [`@media screen and (max-width: ${TABLET_SCREEN_SIZE}px)`]: {
        padding: `${0}px ${TABLET_HORIZONTAL_PADDING}px`,
    },
    [`@media screen and (max-width: ${MOBILE_SCREEN_SIZE}px)`]: {
        padding: `${0}px ${MOBILE_HORIZONTAL_PADDING}px`,
    },
});
const findMostCommonBrandId = (searchProducts) => {
    const brandCounts = new Map();
    let mostCommonBrandId = undefined;
    let maxCount = 0;
    for (const product of searchProducts) {
        const count = (brandCounts.get(product.brandId) || 0) + 1;
        brandCounts.set(product.brandId, count);
        if (count >= maxCount) {
            maxCount = count;
            mostCommonBrandId = product.brandId;
        }
    }
    return mostCommonBrandId;
};
const SearchHeader = styled(Grid)(({ theme }) => ({
    flexDirection: 'row',
    justifyContent: 'space-between',
    color: theme.vars.palette.text.primary,
    marginBottom: 38,
    marginTop: 30,
    '.headerText': {
        fontSize: 16,
        fontWeight: 600,
    },
}));
const PaginationContainer = styled('div')({
    textAlign: 'right',
    [`@media screen and (max-width: ${TABLET_SCREEN_SIZE}px)`]: {
        fontSize: 20,
    },
});
const SearchResults = (_a) => {
    var _b, _c, _d;
    var { LinkComponent, apolloClient, useSearchParams, pageContext, onShareClick, handleJoinClub, useNavigate, appConfig } = _a, props = __rest(_a, ["LinkComponent", "apolloClient", "useSearchParams", "pageContext", "onShareClick", "handleJoinClub", "useNavigate", "appConfig"]);
    const [popularProducts, setPopularProducts] = useState([]);
    const navigate = useNavigate();
    const locationPathname = window.location.pathname;
    const [searchParams, setSearchParams] = useSearchParams();
    const [loading, setLoading] = useState(true);
    const [totalResultCount, setTotalResultCount] = useState(0);
    const [filterDialogOpen, setFilterDialogOpen] = useState(false);
    const [mostPopularBrand, setMostPopularBrand] = useState(undefined);
    const [facets, setFacets] = useState(null);
    const searchRequestBody = searchParamsToSearchFilters(searchParams, pageContext);
    const searchTerms = (_b = searchRequestBody === null || searchRequestBody === void 0 ? void 0 : searchRequestBody.titleInclude) === null || _b === void 0 ? void 0 : _b.join(' ');
    const searchText = searchTerms !== null && searchTerms !== void 0 ? searchTerms : 'All products';
    const [searchInputText, setSearchInputText] = useState(searchTerms);
    const isSignedIn = !!props.userProfile;
    const { joinedState, handleJoin, campaignRewards } = useJoinBrandClubWithRedirect({
        brand: mostPopularBrand,
        handleJoinClub: handleJoinClub,
        navigate,
    });
    const fetchBrandclub = useCallback((brandIds = [], searchTerm) => __awaiter(void 0, void 0, void 0, function* () {
        var _e, _f, _g;
        let titleInclude = undefined;
        if (searchTerm && !brandIds.length) {
            titleInclude = [searchTerm];
        }
        try {
            const RES_KEY = isSignedIn ? 'SearchBrandClubsForUserV2' : 'UnauthedSearchBrandClubs';
            const query = isSignedIn ? searchBrandClubsForUserV2 : getUnauthedSearchBrandClubs;
            const res = yield apolloClient.query({
                query,
                variables: {
                    page: {
                        start: 0,
                        size: 1,
                    },
                    titleInclude,
                    brandIds,
                    searchIntent: 'InAppSearch',
                },
                fetchPolicy: 'network-only',
            });
            setMostPopularBrand((_g = (_f = (_e = res === null || res === void 0 ? void 0 : res.data) === null || _e === void 0 ? void 0 : _e[RES_KEY]) === null || _f === void 0 ? void 0 : _f.items) === null || _g === void 0 ? void 0 : _g[0]);
        }
        catch (e) {
            console.error(e);
            return undefined;
        }
    }), [isSignedIn]);
    useEffect(() => {
        // Update the search input text when the search terms change
        setSearchInputText(searchTerms);
    }, [searchTerms]);
    useEffect(() => {
        // close the filter dialog when the location changes
        setFilterDialogOpen(false);
    }, [locationPathname]);
    const page = _toNumber(searchParams.get('page'));
    const movePrev = () => {
        searchParams.set('page', `${page - PAGE_SIZE}`);
        window.scrollTo({ top: 0, behavior: 'auto' });
        setSearchParams(searchParams);
    };
    const moveNext = () => {
        searchParams.set('page', `${page + PAGE_SIZE}`);
        window.scrollTo({ top: 0, behavior: 'auto' });
        setSearchParams(searchParams);
    };
    useEffect(() => {
        if (apolloClient) {
            const fetchProducts = () => __awaiter(void 0, void 0, void 0, function* () {
                var _a, _b, _c, _d, _e, _f, _g, _h, _j;
                setLoading(true);
                const treatment = (pageContext === null || pageContext === void 0 ? void 0 : pageContext.abTestingTreatments) && (pageContext === null || pageContext === void 0 ? void 0 : pageContext.abTestingTreatments.searchImprovementTreatment)
                    ? {
                        search: pageContext === null || pageContext === void 0 ? void 0 : pageContext.abTestingTreatments.searchImprovementTreatment,
                    }
                    : undefined;
                const { data } = yield apolloClient.query({
                    query: UNAUTHENTICATED_SEARCH_PRODUCTS,
                    variables: Object.assign(Object.assign({}, searchRequestBody), { page: {
                            start: page,
                            size: PAGE_SIZE,
                        }, computeFacets: true, facetFieldNames: ['categoryId', 'retailerId', 'subCategoryId', 'brandId'], treatment }),
                });
                // only fetch the brandclub if we are on the first page and the store branding is universal
                if (page === 0 && ((_a = appConfig === null || appConfig === void 0 ? void 0 : appConfig.domainConfig) === null || _a === void 0 ? void 0 : _a.storeBrandingType) === StoreBrandingType.UniversalStore) {
                    const mostPopularBrandId = findMostCommonBrandId(
                    // The brandclub app only fetches 20 products at a time and only use those 20 to calculate the most popular brand.
                    // To ensure we display the same results even though we fetch more products, we only use the first 20 products and only on the first page.
                    // See https://gitlab.com/stackline-dev/brandclub-mobile-app/-/blob/5e55fd3d9da2211dbb7194745e8aa87da9e4606c/src/screens/Shop/SearchResultsPage.tsx#L203 for reference
                    (_c = (_b = data === null || data === void 0 ? void 0 : data[ProductOperation.UnauthenticatedSearch]) === null || _b === void 0 ? void 0 : _b.products) === null || _c === void 0 ? void 0 : _c.slice(0, 20));
                    yield fetchBrandclub(mostPopularBrandId != null ? [mostPopularBrandId] : undefined, searchTerms);
                }
                setTotalResultCount((_e = (_d = data === null || data === void 0 ? void 0 : data[ProductOperation.UnauthenticatedSearch]) === null || _d === void 0 ? void 0 : _d.totalProducts) !== null && _e !== void 0 ? _e : 0);
                setPopularProducts((_g = (_f = data === null || data === void 0 ? void 0 : data[ProductOperation.UnauthenticatedSearch]) === null || _f === void 0 ? void 0 : _f.products) !== null && _g !== void 0 ? _g : []);
                setFacets((_j = (_h = data === null || data === void 0 ? void 0 : data[ProductOperation.UnauthenticatedSearch]) === null || _h === void 0 ? void 0 : _h.facets) !== null && _j !== void 0 ? _j : null);
                setLoading(false);
            });
            fetchProducts();
        }
    }, [apolloClient, appConfig, searchParams, fetchBrandclub]);
    const hasResults = !loading && popularProducts.length;
    const disableBack = page === 0;
    const totalPages = Math.ceil(totalResultCount / PAGE_SIZE);
    const disableNext = page + 1 >= totalPages;
    return (React__default.createElement(SearchResultsContainer, null,
        React__default.createElement(ContentWrapper, null,
            React__default.createElement(FilterDialog, { searchInput: searchInputText, setSearchInput: setSearchInputText, brandId: (_c = props.brandEntity) === null || _c === void 0 ? void 0 : _c.id, routePrefix: props.routePrefix, navigate: navigate, open: filterDialogOpen, onClose: () => setFilterDialogOpen(false), persistentQueryParams: props.persistentQueryParams, searchParams: searchParams, pageContext: pageContext, axios: props.axios, facets: facets }),
            React__default.createElement(SearchHeader, { container: true, wrap: "nowrap", gap: 1 }, loading ? (React__default.createElement("div", { className: "headerText" },
                ' ',
                React__default.createElement(Typography, { component: "h2", fontSize: 24, fontWeight: "bold", display: "inline-flex", alignItems: "center", overflow: "hidden", whiteSpace: "nowrap", sx: {
                        [`@media screen and (max-width:  390px)`]: {
                            display: 'inline',
                            textOverflow: 'ellipsis',
                        },
                    } }, "Searching..."))) : hasResults ? (React__default.createElement(React__default.Fragment, null,
                React__default.createElement(Typography, { component: "h2", fontSize: 24, fontWeight: "bold", display: "inline-flex", alignItems: "center", overflow: "hidden", whiteSpace: "nowrap", sx: {
                        [`@media screen and (max-width:  390px)`]: {
                            display: 'inline',
                            textOverflow: 'ellipsis',
                        },
                    } },
                    "Search results for \u201C",
                    React__default.createElement(Box, { component: "span", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }, searchText),
                    "\u201D"),
                React__default.createElement(Button, { sx: { height: 'auto', whiteSpace: 'nowrap' }, onClick: () => setFilterDialogOpen(true) }, "Filter"))) : (React__default.createElement("div", { className: "headerText" },
                "No search results were returned for \u201C",
                searchText,
                "\u201D. Please try another query."))),
            React__default.createElement(SearchProductGrid, { onShareClick: onShareClick, loading: loading, LinkComponent: LinkComponent, products: popularProducts }, mostPopularBrand && (React__default.createElement(ProductBrandCard, { brand: mostPopularBrand, joinedState: joinedState, reward: ((_d = campaignRewards[0]) === null || _d === void 0 ? void 0 : _d.rewardAmount) || 0, joined: mostPopularBrand.isMember, onJoin: handleJoin, LinkComponent: LinkComponent }))),
            hasResults && (!disableBack || !disableNext) ? (React__default.createElement(PaginationContainer, null,
                React__default.createElement(IconButton, { disableRipple: true, disableFocusRipple: true, onClick: movePrev, disabled: disableBack },
                    React__default.createElement(ChevronLeftIcon, { sx: (theme) => ({ color: theme.vars.palette.text.primary, opacity: disableBack ? 0.5 : 1 }) })),
                React__default.createElement(IconButton, { disableRipple: true, disableFocusRipple: true, onClick: moveNext, disabled: disableNext },
                    React__default.createElement(ChevronRightIcon, { sx: (theme) => ({ color: theme.vars.palette.text.primary, opacity: disableNext ? 0.5 : 1 }) })))) : null)));
};

export { SearchResults };
//# sourceMappingURL=SearchResults.js.map
